import React from 'react';
import { education } from '../data.js';

export default function Education({sectionBg}) {
   const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";
  // Sort education by end date descending (most recent first)
  const sortedEducation = [...education].sort((a, b) => {
    const extractEndYear = (date) => {
      const match = date.match(/\d{4}$/);
      return match ? parseInt(match[0], 10) : 0;
    };
    return extractEndYear(b.date) - extractEndYear(a.date);
  });

  return (
    <section id="education" className={sectionBg + " py-16"}>
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-12 text-center">Education</h2>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {sortedEducation.map((edu, index) => (
            <div
              key={index}
              className={cardBg + " rounded-xl shadow-md hover:shadow-lg transition transform hover:-translate-y-1 p-6 flex flex-col"}
            >
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">{edu.school}</h3>
                  {/* Location immediately below institute name */}
                  {edu.location && (
                    <p className="text-gray-500 mt-1">{edu.location}</p>
                  )}
                </div>
                <span className="text-sm text-gray-500 font-medium">{edu.date}</span>
              </div>

              <p className="text-gray-700 mt-4 font-medium">{edu.degree}</p>
              
              {edu.affiliation && (
                <p className="text-gray-600 mt-1">{edu.affiliation}</p>
              )}
              {edu.grade && <p className="text-gray-600 mt-2">Grade: {edu.grade}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
